import React from 'react';
import styles from './chatbot.module.scss';

const ChatSidebar = ({
    isSidebarOpen,
    onToggleSidebar,
    onNewChat,
    conversations,
    currentConversationId,
    onLoadChat,
    activeMenuId,
    onToggleMenu,
    onOpenRenameModal,
    onOpenDeleteModal,
    userData,
    syncing,
    syncSeconds,
    syncNotice,
    onSyncDocuments,
    onGoToDashboard
}) => {
    return (
        <div className={`${styles.sidebar} ${!isSidebarOpen ? styles.sidebarCollapsed : ''}`}>
            <button
                type="button"
                onClick={onToggleSidebar}
                title={isSidebarOpen ? 'Collapse Sidebar' : 'Expand Sidebar'}
                className={styles.sidebarToggle}
            >
                <i className={`bi ${isSidebarOpen ? 'bi-chevron-left' : 'bi-chevron-right'}`}></i>
            </button>
            <div className={styles.sidebarActions}>
                <button
                    type="button"
                    className={styles.newChatBtn}
                    onClick={onNewChat}
                >
                    <i className="bi bi-pencil-square"></i>
                    {isSidebarOpen && <span>New Chat</span>}
                </button>
            </div>
            {isSidebarOpen && (
                <>
                    <div className={styles.historyLabel}>Your chats</div>
                    <div className={styles.historyList}>
                        {conversations.map((chat) => (
                            <div
                                key={chat.id}
                                className={`${styles.historyItem} ${(currentConversationId === chat.id) ? styles.active : ''}`}
                                onClick={() => onLoadChat(chat)}
                            >
                                <div className={styles.historyItemContent}>
                                    <i className="bi bi-chat-left-text"></i> {chat.title || `Chat ${chat.id}`}
                                </div>
                                <div className={styles.menuContainer}>
                                    <button
                                        className={styles.menuButton}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onToggleMenu(chat.id);
                                        }}
                                    >
                                        <i className="bi bi-three-dots-vertical"></i>
                                    </button>
                                    {activeMenuId === chat.id && (
                                        <div className={styles.dropdownMenu}>
                                            <div className={styles.dropdownItem} onClick={(event) => onOpenRenameModal(chat, event)}>
                                                <i className="bi bi-pencil"></i> Rename
                                            </div>
                                            <div className={`${styles.dropdownItem} ${styles.deleteItem}`} onClick={(event) => onOpenDeleteModal(chat, event)}>
                                                <i className="bi bi-trash"></i> Delete
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className={styles.sidebarFooter}>
                        <div className={styles.creditsContainer}>
                             <div className={styles.creditsWrapper}>
                                <div className={styles.creditsCircle}>
                                    <i className="bi bi-lightning-fill"></i>
                                </div>
                                <div className={styles.creditsInfo}>
                                    <div className={styles.creditsLabel}>Credits Remaining</div>
                                    <div className={styles.creditsValue}>{userData?.available_credits || 0}</div>
                                </div>
                             </div>
                        </div>
                        
                        <div className={styles.footerActions}>
                            <button onClick={onGoToDashboard} className={styles.dashboardBtn}>
                                <i className="bi bi-grid-fill"></i>
                                <span>Dashboard</span>
                            </button>
                            <button
                                type="button"
                                onClick={onSyncDocuments}
                                className={`${styles.dashboardBtn} ${styles.syncBtn}`}
                                disabled={syncing}
                                data-test="sync-sharepoint"
                                title="Sync SharePoint documents into the chatbot knowledge base"
                            >
                                <i className={`bi bi-arrow-repeat ${syncing ? styles.syncingIcon : ''}`}></i>
                                <span>{syncing ? `${Math.floor(syncSeconds / 60)}:${String(syncSeconds % 60).padStart(2, '0')}` : 'Sync docs'}</span>
                            </button>
                        </div>
                        {syncNotice && (
                            <div
                                className={`${styles.syncNotice} ${
                                    syncNotice.variant === 'danger'
                                        ? styles.syncError
                                        : syncNotice.variant === 'warning' ? styles.syncWarning : ''
                                }`}
                                role="status"
                                aria-live="polite"
                            >
                                <strong>{syncNotice.title}</strong>
                                <span>{syncNotice.message}</span>
                                {!!syncNotice.failures.length && (
                                    <details>
                                        <summary>Review details</summary>
                                        <ul>{syncNotice.failures.map(failure => <li key={failure}>{failure}</li>)}</ul>
                                    </details>
                                )}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default ChatSidebar;
